import React, { useState, useEffect } from 'react';
import './DataWarningPopup.css';

const DataWarningPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already seen the warning in this session
    // Using sessionStorage so it shows once per visit
    const hasSeenWarning = sessionStorage.getItem('dataWarningSeen');
    if (!hasSeenWarning) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500); // Show after a short delay
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem('dataWarningSeen', 'true');
    }, 400); // Match animation duration
  };

  if (!isVisible) return null;

  return (
    <div className={`data-warning-overlay ${isClosing ? 'fade-out' : 'fade-in'}`}>
      <div className={`data-warning-content ${isClosing ? 'popup-exit' : 'popup-enter'}`}>
        <div className="data-warning-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M12 7V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="12" cy="16.5" r="1" fill="currentColor"/>
          </svg>
        </div>
        
        <div className="data-warning-text">
          <h3>Connection Notice</h3>
          <p>Please use Broadband / WIFI connection.</p>
          <p className="subtext">The photo file size is large. More internet data may be used.</p>
        </div>

        <button onClick={handleClose} className="data-warning-btn">
          I Understand
        </button>
      </div>
    </div>
  );
};

export default DataWarningPopup;
